<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  @if (this.isSuccess) {
    <div class="alert alert-success">Product group was updated successfully</div>
  }
  <div class='sheet'>
    <h1 class='header'>Edit Product Group - {{ this.productGroup.name }}</h1>
    <app-audit-line [data]='this.productGroup'></app-audit-line>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-product-group-form [productGroup]='this.productGroup'></app-product-group-form>
      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/warehousing/product-groups'>Cancel</button>
    </form>
  </div>
</div>
